import { useNavigate } from "react-router-dom";
import { ROUTES } from "#root/routes/constants";
import { Incident } from "#root/queries/incidents";
import { Button } from "@fluentui/react-components";
import { Edit20Filled, Delete20Filled, QrCode24Filled, DocumentBulletList24Filled, Location24Filled } from "@fluentui/react-icons";
import BaseIncidentsList, { IncidentActionHandlers } from "#root/components/BaseIncidentsList";
import { useVAdminSelectedIncident } from "#root/queries/local";

const Merrge211: React.FC = () => {
  const navigate = useNavigate();
  const { selectedIncidentId, setVAdminSelectedIncidentId } = useVAdminSelectedIncident();

  // Handle incident selection change
  const handleIncidentChange = (id: string) => {
    setVAdminSelectedIncidentId(id);
  };

  // Handle locations button click
  const handleLocationsClick = (incident: Incident) => {
    navigate(`${ROUTES.MERRGE211.INCIDENT_LOCATIONS}?incidentId=${incident.id}`);
  };

  // Render action buttons for Merrge211 incidents
  const renderMerrge211Actions = (incident: Incident, handlers: IncidentActionHandlers) => (
    <>
      {incident.isActive && (
        <>
          <Button
            className="expanding-action-button"
            appearance="transparent"
            icon={<QrCode24Filled />}
            onClick={(e) => handlers.onQRCode(incident, e)}
          >
            <span className="button-text">Share QR</span>
          </Button>
          <Button
            className="expanding-action-button"
            appearance="transparent"
            icon={<DocumentBulletList24Filled />}
            onClick={(e) => handlers.onCreateReport(incident, e)}
          >
            <span className="button-text">Create Status Report</span>
          </Button>
          <Button
            className="expanding-action-button"
            appearance="transparent"
            icon={<Location24Filled />}
            onClick={() => handleLocationsClick(incident)}
          >
            <span className="button-text">Locations</span>
          </Button>
        </>
      )}
      <Button
        className="expanding-action-button"
        appearance="transparent"
        icon={<Edit20Filled />}
        onClick={(e) => handlers.onEdit(incident, e)}
      >
        <span className="button-text">Edit</span>
      </Button>
      {!incident.isActive && (
        <Button
          className="expanding-action-button"
          appearance="transparent"
          icon={<Delete20Filled />}
          onClick={(e) => handlers.onDelete(incident, e)}
        >
          <span className="button-text">Delete</span>
        </Button>
      )}
    </>
  );

  const actionCards = [
    {
      image: "responder-check-in",
      title: "Responder Check In",
      onClick: () => navigate(ROUTES.MERRGE211.RESPONDER_CHECK_IN),
    },
    {
      image: "approved-responders",
      title: "Approved Responders",
      onClick: () => navigate(ROUTES.MERRGE211.APPROVED_RESPONDERS),
    },
    {
      image: "checked-in-deployable",
      title: "Checked In/Deployable",
      onClick: () => navigate(ROUTES.MERRGE211.CHECKED_IN_DEPLOYABLE),
    },
    {
      image: "meal-tracking",
      title: "Meal Tracking by Meal and Snacks",
      onClick: () => navigate(ROUTES.MERRGE211.MEAL_TRACKING),
    },
    {
      image: "after-action-report",
      title: "Status Report",
      onClick: () => navigate(ROUTES.MERRGE211.STATUS_REPORT),
    },
    {
      image: "time-and-travel",
      title: "Time and Travel",
      onClick: () => navigate(ROUTES.MERRGE211.TIME_AND_TRAVEL),
    },
    {
      image: "status-map",
      title: "Status Map",
      onClick: () => navigate(ROUTES.MERRGE211.STATUS_MAP),
    }
  ];

  const generateQrUrl = (tenantId?: string, incidentId?: string) => {
    return `${window.location.origin}${ROUTES.RESPONDER_REGISTRATION}?tenantId=${tenantId}&incidentId=${incidentId}`;
  };

  return (
    <BaseIncidentsList
      className="merrge211"
      actionCards={actionCards}
      renderActions={renderMerrge211Actions}
      generateQrUrl={generateQrUrl}
      initialIncidentId={selectedIncidentId || ''}
      onIncidentChange={handleIncidentChange}
    />
  );
};

export default Merrge211;